import { isPlatformServer } from '@angular/common';
import { PLATFORM_ID, inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { WhiteLabelApplicationService } from '../services/white-label-application.service';
import { CurrentWhiteLabelApplication } from '../utils/current-white-label-application';

export const notProjectAppGuard: CanActivateFn = async () => {
  const app = inject(CurrentWhiteLabelApplication);
  const whiteLabelApplicationService = inject(WhiteLabelApplicationService);
  const router = inject(Router);
  const platformId = inject(PLATFORM_ID);

  if (isPlatformServer(platformId)) {
    return true;
  }

  await whiteLabelApplicationService.waitUntilReady();

  return app.isProjectApp() ? router.parseUrl('/feed') : true;
};
